<script setup lang="ts">
import { useUserStore } from '@/stores/user';
import { releaseNotes } from '@/releaseNotes';

const userStore = useUserStore();
</script>

<template>
  <div class="about mt-3">
    <div class="mb-4">
      <h3>User Info</h3>
      <p>Name: {{ userStore.user?.name }}</p>
      <p>Username: {{ userStore.user?.username }}</p>
    </div>

    <div>
      <h3>Release Notes</h3>
      <div v-for="release in releaseNotes" :key="release.version" class="mb-4">
        <h5>
          Version {{ release.version }} <small class="text-muted">{{ release.date }}</small>
        </h5>
        <div v-for="section in release.sections" :key="section.title" class="mb-2">
          <h6>{{ section.title }}</h6>
          <ul>
            <li v-for="item in section.items" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    margin: 1rem;
    display: flex;
    flex-direction: column;
  }
}
</style>
